import { render } from "./ResizeTextarea.vue?vue&type=template&id=070282ec"
import script from "./ResizeTextarea.vue?vue&type=script&lang=js"
export * from "./ResizeTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__